const isLocalhost = globalThis.location?.host?.startsWith('localhost') ?? false

/** Beta domain used for OAuth redirects when running locally */
const BETA_DOMAIN = 'https://beta.comply.clinicallyai.com'

/** URL to redirect to after successful Google login */
export const REDIRECT_URI = isLocalhost
  ? `${BETA_DOMAIN}/login`
  : `${globalThis.location.protocol}//${globalThis.location.host}/login`

/** URL to redirect to after successful Microsoft login */
export const MS_REDIRECT_URI = isLocalhost
  ? `${BETA_DOMAIN}/mslogin`
  : `${globalThis.location.protocol}//${globalThis.location.host}/mslogin`

/** URL to redirect to after successful Apple login */
export const APPLE_REDIRECT_URI = isLocalhost
  ? `${BETA_DOMAIN}/api/apple-login`
  : `${globalThis.location.protocol}//${globalThis.location.host}/api/apple-login`
